<script lang="ts" setup>
import { ApiAssistanceServicesDetail } from '~~/server/api/insurance/assistance-services/[slug]'

const { $t } = useNuxtApp()
const route = useRoute()

const { data: page, redirect } = await useFetchWithRedirect<ApiAssistanceServicesDetail>(
    () => `/api/insurance/assistance-services/${route.params.id}?filter=${
        route.query.filter || ''
    }&products_id=${route.query.products_id || ''}`,
    { route },
    { watch: [() => route.query.products_id, () => route.query.filter] }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

// Schema.org
useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
    }),
])

const breadcrumbs = computed<BreadcrumbsLink[]>(() => {
    return [
        {
            name: $t('Asistenčné služby'),
            slug: useNamedRoutes({ name: 'assistance-services' }),
        },
    ]
})

const productsList = computed<string>(
    () => page.value?.data.products?.join(', ') as string
)

if (Object.keys(route.query).length > 0) {
    useCanonicalHead({})
}

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
    og_type: 'product'
})
</script>

<template>
  <section v-if="page">
    <ContainerFluid>
      <Breadcrumbs
        :current="page.data.title"
        :links="breadcrumbs"
      />
    </ContainerFluid>

    <ContainerFluid>
      <PageHeaderContent
        class="pt-12 pb-12 border-top"
        :tag="$t('Asistenčná služba')"
        :title="page.data.title"
        text-color="black-100"
      />

      <PagesAssistenceServicesBenefitHeading
        v-if="page.data.subtitle"
        class="mb-12 mb-md-20"
        :subtitle="page.data.subtitle"
        :products-list="productsList"
      />

      <LazyWidgetAssistanceServices
        v-if="page.data.services.length > 0"
        class="mb-12 mb-md-20"
        :data="page.data"
      />

      <div class="pt-12 pt-md-20 border-top">
        <LazyWidgetHelpdeskExt />
      </div>
    </ContainerFluid>
  </section>
</template>
